import React, { useState, useEffect, Fragment, useRef } from "react";
import Multiselect from 'multiselect-react-dropdown';
import CsVersionUpdate from "../../models/CsVersionUpdate";
import { toast } from "react-toastify";
import { externalUrl } from "../../data/externalUrls.js";
import axios from "axios";

const FormPartial = (props) => {
  const { csVersionUpdate, setCsVersionUpdate, setIsLoading } = props
  let csVersionUpdateObj = new CsVersionUpdate(csVersionUpdate);
  const [chargingStations, setChargingStations] = useState([]);
  const circleRef = useRef();
  const cityRef = useRef();
  const chargingZoneRef = useRef();
  const deviceIDRef = useRef();
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    fetchChargingStations();
  }, []);

  useEffect(() => {
    let csData = chargingStations.filter(item => csVersionUpdateObj['device_ids'].includes(item['device_id']));
    setTableData(csData.map(
      ({ circle, city, charging_zone, device_id, battery_swap_count_yesterday, current_android_version, android_version_last_updated_at, current_bin_version, bin_version_last_updated_at}) =>
      ({ circle, city, charging_zone, device_id, battery_swap_count_yesterday, current_android_version, android_version_last_updated_at, current_bin_version, bin_version_last_updated_at})));
  }, [csVersionUpdateObj.device_ids])

  const fetchChargingStations = async () => {
    try {
      setIsLoading(true);
      await axios.get(`${externalUrl.flaskServiceUrl}/CS_Diagnostics/charging_stations`)
      .then((response) => {
        if (response?.data?.data && response?.data?.data.length > 0) {
          setChargingStations(response?.data?.data);
        } else {
          toast.warning("Charging stations are null or not found.")
        }
      })
      .catch(error => {
        toast.error(error?.message);
      });
    } catch (error) {
      toast.error(error.data?.message || 'Something went wrong !');
    } finally {
      setIsLoading(false)
    }
  }

  const validateValue = (field) => {
    csVersionUpdateObj.validate(field);
    if (field === 'circle_ids' || field === 'city_ids' || field === 'charging_zone_ids'){
      csVersionUpdateObj.validate('device_ids');
    }
    if(field === 'version'){
      csVersionUpdateObj.validate('type');
    } else if (field === 'type'){
      csVersionUpdateObj.validate('version');
    }
  }

  const changeValue = (field, value) => {
    csVersionUpdateObj[field] = value;
    validateValue(field);
    setCsVersionUpdate(csVersionUpdateObj.toStateJson());
  }

  const onMultiSelect = (key, selectedItem, ogKey) => {
    if(key !== 'device_ids') {
      csVersionUpdateObj['device_ids'] =
      chargingStations.filter((item) => (csVersionUpdateObj[key] + selectedItem[ogKey]).includes(item[ogKey])).map(item => item['device_id']);
    }
    resetSelectedOptions(ogKey);
    csVersionUpdateObj[key].push(selectedItem[ogKey]);
    validateValue(key);
    setCsVersionUpdate(csVersionUpdateObj.toStateJson());
  }

  const onMultiRemove = (key, removedItem, ogKey) => {
    csVersionUpdateObj[key] = csVersionUpdateObj[key].filter((item) => item !== removedItem[ogKey]);
    validateValue(key);
    resetSelectedOptions(ogKey);
    if (key !== 'device_ids') {
      csVersionUpdateObj['device_ids'] =
      chargingStations.filter((item) => (
          csVersionUpdateObj['charging_zone_ids'].length > 0 ?
          csVersionUpdateObj['charging_zone_ids'].includes(item['charging_zone']) :
          csVersionUpdateObj['city_ids'].length > 0 ?
          csVersionUpdateObj['city_ids'].includes(item['city']) :
          csVersionUpdateObj['circle_ids'].includes(item['circle'])
        )).map(item => item['device_id']);
    }
    setCsVersionUpdate(csVersionUpdateObj.toStateJson());
  }

  const resetSelectedOptions = (ogKey) => {
    if (ogKey === 'circle') {
      cityRef.current.resetSelectedValues();
      chargingZoneRef.current.resetSelectedValues();
      csVersionUpdateObj['city_ids'] = [];
      csVersionUpdateObj['charging_zone_ids'] = [];
    }
    else if (ogKey === 'city') {
      chargingZoneRef.current.resetSelectedValues();
      csVersionUpdateObj['charging_zone_ids'] = [];
    }
  }

  const filterUniqueOptions = (array, key) => {
    const uniqueMap = new Map();
    array.forEach(item => {
      if (!uniqueMap.has(item[key])) {
        uniqueMap.set(item[key], item);
      }
    });
    const options = Array.from(uniqueMap.values());
    if (key === 'city') {
      return filterOptions(options, 'circle_ids', 'circle');
    }
    else if (key === 'charging_zone') {
      return filterOptions(options, 'city_ids', 'city');
    }
    else if (key === 'device_id') {
      let deviceIdOptions =
        csVersionUpdateObj['charging_zone_ids'].length > 0 ?
        filterOptions(options, 'charging_zone_ids', 'charging_zone') :
        csVersionUpdateObj['city_ids'].length > 0 ?
        filterOptions(options, 'city_ids', 'city') :
        csVersionUpdateObj['circle_ids'].length > 0 ?
        filterOptions(options, 'circle_ids', 'circle') :
        [];
      return deviceIdOptions;
    }
    else {
      return options;
    }
  };

  const filterOptions = (optionsArray, key, ogKey) => {
    return optionsArray.filter(item => csVersionUpdateObj[key].includes(item[ogKey]) )
  }

  const beautifyString = (hash) => {
    return hash.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
  }

  return <Fragment>
    <div className="col-md-6">
      <label htmlFor='circle_ids' className="form-label mb-1">Circle</label>
      <Multiselect
        id='circle_ids'
        options={filterUniqueOptions(chargingStations, 'circle')}
        selectedValues={chargingStations.filter((item) => item['circle'] === csVersionUpdateObj['circle_ids']) || []}
        displayValue={'circle'}
        avoidHighlightFirstOption={true}
        onSelect={(selectedList, selectedItem) => onMultiSelect("circle_ids", selectedItem, 'circle')}
        onRemove={(selectedList, removedItem) => onMultiRemove("circle_ids", removedItem, 'circle')}
        customArrow={true}
        placeholder='Select Circle'
        ref={circleRef}
      />
    </div>
    <div className="col-md-6">
      <label htmlFor='city_ids' className="form-label mb-1">City</label>
      <Multiselect
        id='city_ids'
        options={filterUniqueOptions(chargingStations, 'city')}
        selectedValues={chargingStations.filter((item) => item['city'] === csVersionUpdateObj['city_ids']) || []}
        displayValue={'city'}
        avoidHighlightFirstOption={true}
        onSelect={(selectedList, selectedItem) => onMultiSelect("city_ids", selectedItem, 'city')}
        onRemove={(selectedList, removedItem) => onMultiRemove("city_ids", removedItem, 'city')}
        customArrow={true}
        placeholder='Select City'
        ref={cityRef}
      />
    </div>
    <div className="col-md-6">
      <label htmlFor='charging_zone_ids' className="form-label mb-1">Charging Zone</label>
      <Multiselect
        id='charging_zone_ids'
        options={filterUniqueOptions(chargingStations, 'charging_zone')}
        selectedValues={chargingStations.filter((item) => item['charging_zone'] === csVersionUpdateObj['charging_zone_ids']) || []}
        displayValue={'charging_zone'}
        avoidHighlightFirstOption={true}
        onSelect={(selectedList, selectedItem) => onMultiSelect("charging_zone_ids", selectedItem, 'charging_zone')}
        onRemove={(selectedList, removedItem) => onMultiRemove("charging_zone_ids", removedItem, 'charging_zone')}
        customArrow={true}
        placeholder='Select Charging Zone'
        ref={chargingZoneRef}
      />
    </div>
    <div className="col-md-6">
      <label htmlFor='device_ids' className="form-label mb-1">Charging Station</label>
      <Multiselect
        id='device_ids'
        options={filterUniqueOptions(chargingStations, 'device_id')}
        selectedValues={chargingStations.filter((item) => csVersionUpdateObj['device_ids'].includes(item['device_id'])) || []}
        displayValue={'device_id'}
        avoidHighlightFirstOption={true}
        onSelect={(selectedList, selectedItem) => onMultiSelect("device_ids", selectedItem, 'device_id')}
        onRemove={(selectedList, removedItem) => onMultiRemove("device_ids", removedItem, 'device_id')}
        customArrow={true}
        placeholder='Select Charging Station'
        ref={deviceIDRef}
      />
      <div id="device_ids_help" className="form-text text-danger mt-0">
        {csVersionUpdateObj.errors.device_ids}
      </div>
    </div>
    {
      tableData.length > 0 &&
      <div className="custom-scrollbar border rounded pb-2" style={{ maxHeight: '380px', overflow: 'auto'}}>
        <table className="table table-sm table-borderless">
          <thead className="table-success" style={{ position: "sticky", top: "0", height: '40px' }}>
            <tr>
              {tableData[0] && Object.keys(tableData[0]).map((heading) => {
                return <th key={`simple_heading${heading}`} scope="col" style={{ minWidth: 'max-content', whiteSpace: 'nowrap' }} className="ps-2">
                  {beautifyString(heading)}
                </th>
              })}
            </tr>
          </thead>
          <tbody>
            {tableData && tableData.map((obj, index) => {
              return <tr key={`simple_data${index}`}>
                {Object.keys(obj).map((key) => {
                  if (obj[key] !== null) {
                    return <td key={`simple_td_${key}`} className="border ps-2">{obj[key]}</td>
                  } else {
                    return <td key={`simple_td_blank${key}`} className="border ps-2">-</td>
                  }
                })}
              </tr>
            })}
          </tbody>
        </table>
      </div>
    }
    <div className="col-md-2 mt-4">
      <label htmlFor="type" className="form-label mb-1">Version Type</label>
      <div className="border py-1 rounded d-flex justify-content-around">
        {csVersionUpdateObj.version_type.length !== 0 && Object.keys(csVersionUpdateObj.version_type).map((type) =>
          {return (
          <span className="mx-2" key={type}>
            <input
              id={type}
              checked={csVersionUpdateObj.type === type}
              className="form-check-input"
              type="radio"
              onChange={(e) => changeValue('type', e.target.id)}
              name="type"
            />
            <label className="form-check-label mx-2" htmlFor={type}>
              {type.charAt(0).toUpperCase() + type.slice(1)}
            </label>
          </span>)}
        )}
      </div>
      <div id="type_help" className="form-text text-danger mt-0">
        {csVersionUpdateObj.errors.type}
      </div>
    </div>
    <div className="col-md-4 mt-4">
      <label htmlFor="version" className="form-label mb-1">Version</label>
      <input
        id="version"
        value={csVersionUpdateObj.version}
        onChange={(e) => changeValue('version', e.target.value)}
        type="text"
        className="form-control form-control-sm font-size-12"
        placeholder='Enter Verson File Name'
        aria-describedby="version_help"
      />
      <div id="version_help" className="form-text text-danger mt-0">
        {csVersionUpdateObj.errors.version}
      </div>
    </div>
    <div className="col-md-6 mt-4">
      <label htmlFor="remarks" className="form-label mb-1">Remark</label>
      <textarea
        id="remarks"
        value={csVersionUpdateObj.remarks}
        onChange={(e) => changeValue('remarks', e.target.value)}
        type="textarea"
        className="form-control form-control-sm font-size-12"
        aria-describedby="remarks_help"
        placeholder='Enter Remarks (Reason)'
      />
      <div id="remarks_help" className="form-text text-danger mt-0">
        {csVersionUpdateObj.errors.remarks}
      </div>
    </div>

  </Fragment>
}

export default FormPartial;
